/**
 * Naming convention for CacheService
 * For all methods that 'save' data, they should start with 'store'
 * For all methods that 'get' data, they should start with 'get'
 */
/* @ngInject */
export default function CacheService($resource, $window) {
    let definitionParameterRanges,
        allDefinitions = [],
        parentDefinitions = [],
        definition = undefined,
        filteredDefinitionParameter,
        comparableUniqueParts,
        valueIds,
        filteredDefinition = {
            isFiltered: false,
            definitions: []
        },
        uniquePartObject,
        notifyMessage,
        previousDefinition,
        originalSearchBoxInput,
        allImages = [],
        seriesImages = [],
        containerInfo
    ;

    return {
        storeConfigurationInfo: function (info) {
            containerInfo = info;
        },
        getConfigurationInfo: function () {
            return containerInfo;
        },
        storeSeriesImages: function (si) {
            seriesImages = si;
        },
        getSeriesImages: function () {
            return seriesImages;
        },
        storeAllImages: function (ai) {
            allImages.length = 0;
            ai.forEach(function (i) {
                allImages.push(i);
            });
        },
        getAllImages: function () {
            return allImages;
        },
        storeAllDefinitions: function (ad) {
            allDefinitions.length = 0;
            ad.forEach(function (a) {
                allDefinitions.push(a);
            });
        },
        getAllDefinitions: function () {
            return allDefinitions;
        },
        storeParentDefinition: function (pd) {
            parentDefinitions.push(pd);
            (parentDefinitions.length > 1)
                ? console.log(parentDefinitions.length + ' Parent Definitions Saved.')
                : console.log(parentDefinitions.length + ' Parent Definition Saved.');
        },
        restoreParentDefinition: function (pds) {
            parentDefinitions.length = 0;
            pds.forEach(function (pd) {
                parentDefinitions.push(pd);
            });
        },
        getParentDefinition: function () {
            return parentDefinitions;
        },
        storeDefinition: function (d) {
            definition = d;
            // if(definition == undefined) {
            //     definition = d;
            //     return;
            // }
            //
            // for(var name in d) {
            //     definition[name] = d[name];
            // }
        },
        getDefinition: function () {
            return definition;
        },
        storePreviousDefinition: function (pd) {
            previousDefinition = pd;
        },
        getPreviousDefinition: function () {
            return definitionParameterRanges;
        },
        storeFilteredDefinitionParameter: function (dp) {
            comparableUniqueParts = undefined;
            filteredDefinitionParameter = dp;
        },
        getFilteredDefinitionParameter: function () {
            return filteredDefinitionParameter;
        },
        storeSelectedParameterValueIds: function (ids) {
            comparableUniqueParts = undefined;
            valueIds = ids;
        },
        getSelectedParameterValueIds: function () {
            return valueIds;
        },
        storeComparableUniqueParts: function (parts) {
            filteredDefinitionParameter = undefined;
            valueIds = undefined;
            comparableUniqueParts = parts;
        },
        getComparableUniqueParts: function () {
            return comparableUniqueParts;
        },
        storeFilteredDefinition: function (isFiltered, definitions) {
            filteredDefinition.isFiltered = isFiltered;
            filteredDefinition.definitions.length = 0;
            if (definitions !== null && definitions !== undefined) {
                definitions.forEach(function (definition) {
                    filteredDefinition.definitions.push(definition);
                });
            }
        },
        getFilteredDefinition: function () {
            return filteredDefinition;
        },
        getUniquePart: function () {
            return uniquePartObject;
        },
        storeUniquePart: function (upo) {
            uniquePartObject = upo;
        },
        getMessage: function () {
            return notifyMessage;
        },
        setMessage: function (object) {
            notifyMessage = object;
        },
        getOriginalQueryInput: function () {
            return originalSearchBoxInput;
        },
        storeOriginalQueryInput: function (input) {
            if ($window.ga && input !== undefined) {
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'Sleuth',
                    eventAction: 'Search',
                    eventLabel: input
                });
            }

            originalSearchBoxInput = input;
        }
    };
}
